

var activeElements = {};

var MouseObserver = {
	hoverTimeout: undefined,
	hoverDelay: 200
};

var keyboardHelper = (function() {
	var keys = {
		ENTER: 13,
		ESCAPE: 27,
		SPACEBAR: 32,
		LEFTARROW: 37,
		UPARROW: 38,
		RIGHTARROW: 39,
		DOWNARROW: 40
	};

	return {
		keys: keys,
		isMenuKey: function(keyCode) {
			var keyMatched = false;
			for (var key in keys) {
				if (keys[key] == keyCode) {
					keyMatched = true;
					break;
				}
			}

			return keyMatched;
		}
	}
})();

require([
		'dojo/_base/event',
		'dojo/_base/lang',
		'dojo/dom-class',
		'dojo/dom-style',
		'dojo/has',
		'dojo/on',
		'dojo/query',
		'dojo/sniff',
		'dojo/domReady!',
		'dojo/NodeList-dom',
		'dojo/NodeList-traverse'
	], function(event, lang, domClass, domStyle, has, on, query) {
	'use strict';

	if (dojo.byId('checkoutHeaderIdForJS')) {
		return;
	}

	var desktopNav = (function() {
			var $container = $('#primary-nav'),
					$topLevelNavItems = $('.nav-items > li:not(.mobile-only)'),
					$topLevelContentWrapper = $('.drawer-container'),
					$topLevelContent = $('.drawer'),
					$petNavContainer = $('.pet-list'),
					$petMenuNavItems = $('.pet-list li'),
					$petMenuContent = $('.pet-nav'),
					$navMask = $('.nav-mask'),
					$brandFilters = $('.shop-by-brand-fullpage .brand-filter a'),
					$persistentNav = $('nav > .persistent-utility'),
					initialized = false,
					menuOpenClass = 'focus'; 

			$container
				.find('ul')
					.attr('role', 'menu')
					.end()
				.find('> ul')
					.attr('aria-label', 'Main Navigation')
					.attr('role', 'menubar')
					.end()
				.find('li')
					.attr('role', 'none')
					.end()
				.find('a')
					.attr('role', 'menuitem')
					.attr('tabIndex', -1)
					.end()
				.find('.drawer .container a')
					.attr('tabIndex', 0);
			$topLevelNavItems.find('> a')
				.attr('aria-haspopup', 'true')
				.attr('aria-expanded', 'false')
				.first()
					.attr('tabIndex', 0);
			$topLevelContentWrapper.attr('aria-hidden', 'true');
			$petMenuNavItems.find('> a')
				.attr('aria-haspopup', 'true')
				.attr('aria-expanded', 'false')
				.attr('tabIndex', -1);
			$petMenuContent.attr('aria-hidden', 'true');

			$persistentNav.children('i').each(function(){
				$(this).attr('tabindex', '0');
			});
		function openTopLevelMenuItem($menuItem, focusFirstItem) {
			if (typeof focusFirstItem != 'boolean') {
				focusFirstItem = false;
			}
			var menuAlreadyOpen = $topLevelNavItems.filter('.'+menuOpenClass).length > 0;
			if (MouseObserver.hoverTimeout) {
				clearTimeout(MouseObserver.hoverTimeout);
			}
			MouseObserver.hoverTimeout = setTimeout(function() {
				$topLevelNavItems.filter('.'+menuOpenClass)
					.removeClass(menuOpenClass)
					.find('> a')
						.attr('aria-expanded', 'false')
						.attr('tabIndex', -1);
				$menuItem.addClass(menuOpenClass)
					.find('> a')
						.attr('aria-expanded', 'true')
						.attr('tabIndex', 0);
				$navMask.show();
				$container.find('> ul').addClass('active');

				var drawerId = $menuItem.attr('id');

				$topLevelContent.filter('.'+menuOpenClass)
					.removeClass(menuOpenClass)
					.closest('.drawer-container')
					.attr('aria-hidden', 'true');

				$topLevelContent.each(function() {
					var $content = $(this);
					if ($content.hasClass(drawerId)) {
						$content.addClass(menuOpenClass)
							.closest('.drawer-container')
							.attr('aria-hidden', 'false');
						$content.find('.pet-list li')
							.removeClass(menuOpenClass)
							.first()
								.addClass(menuOpenClass)
							.find('> a')
								.attr('aria-expanded', 'true')
								.attr('tabIndex', 0);
						$content.find('.pet-nav')
							.removeClass(menuOpenClass)
							.first()
								.addClass(menuOpenClass)
								.attr('aria-hidden', false);
					}
				});

				if (focusFirstItem) {
					$menuItem.find('li > a').first().focus();
				}
			}, menuAlreadyOpen ? MouseObserver.hoverDelay : 20);
		}

		function openPetMenuItem($menuItem) {
			$petMenuNavItems.filter('.'+menuOpenClass)
				.removeClass(menuOpenClass)
				.find('> a')
					.attr('aria-expanded', 'false')
					.attr('tabIndex', -1);
			$menuItem.addClass(menuOpenClass)
				.find('> a')
					.attr('aria-expanded', 'true')
					.attr('tabIndex', 0);

			var petId = $menuItem.attr('id');

			$petMenuContent.filter('.'+menuOpenClass)
				.removeClass(menuOpenClass)
				.attr('aria-hidden', 'true');

			$petMenuContent.each(function() {
				var $content = $(this);
				if ($content.hasClass(petId)) {
					$content.addClass(menuOpenClass)
						.attr('aria-hidden', 'false');
				}
			});
		}

		function dismissDesktopNav(refocusTopItem) {
			if (typeof refocusTopItem != 'boolean') {
				refocusTopItem = false;
			}
			var mainNavOpen = $topLevelNavItems.filter('.'+menuOpenClass).length > 0;
			var $currentTopLevelMenuItem = mainNavOpen ?
				$topLevelNavItems.filter('.'+menuOpenClass) :
				$topLevelNavItems.has('> a[tabindex="0"]');

			$topLevelNavItems.removeClass(menuOpenClass)
				.find('> a')
					.attr('aria-expanded', 'false')
					.attr('tabIndex', -1);
			$currentTopLevelMenuItem.find('> a')
				.attr('tabIndex', 0);
			if (refocusTopItem) {
				$currentTopLevelMenuItem.find('> a')
				.focus();
			}
			$topLevelContent.removeClass(menuOpenClass);
			$petMenuNavItems.removeClass(menuOpenClass)
				.find('> a')
					.attr('aria-expanded', 'false')
					.attr('tabIndex', -1);
			$navMask.hide();
			$container.find('> ul').removeClass('active');
			$topLevelContentWrapper.attr('aria-hidden', 'true');
			$petMenuContent.removeClass(menuOpenClass)
				.attr('aria-hidden', 'true');
			if (MouseObserver.hoverTimeout) {
				clearTimeout(MouseObserver.hoverTimeout);
			}
		}

		function toggleToplevelMenu($menuItem) {
			if (menuItemIsOpen($menuItem)) {
				dismissDesktopNav(true);
			} else {
				openTopLevelMenuItem($menuItem, true);
			}
		}

		function getPreviousItem($menu, $currentItem) {
			var $prev;
			var  previtem = $currentItem.prevAll().not('.mobile-only').first();
			if (previtem.length) {
				$prev = previtem;
			} else {
				$prev = $menu.last();
			}
			return $prev;
		}

		function getNextItem($menu, $currentItem) {
			var $next;			
			 var nextitem = $currentItem.nextAll().not('.mobile-only').first();
			if (nextitem.length) {
				$next =  nextitem;
			} else {
				$next = $menu.first();
			}
			return $next;
		}

		function menuItemIsOpen($menuItem) {
			return $menuItem.hasClass(menuOpenClass);
		}

		function shiftFocus($menu, $menuItem) {
			$menu.find('> a')
				.attr('tabIndex', -1)
			$menuItem.find('> a')
				.attr('tabIndex', 0)
				.focus();
		}

		function addEventListeners() {
			$container.on('keydown', function(evt) {
				if (evt.target.tagName == "TEXTAREA") {
					return;
				}
				var pressedKey = evt.keyCode;
				if (evt.target.tagName == "I" && (pressedKey === keyboardHelper.keys.ENTER || pressedKey === keyboardHelper.keys.SPACEBAR)) {
					evt.preventDefault();
					if (evt.target.classList.contains('persistent-search')) {
						showSearchElement();
						setTimeout(function() {
							$('input#SimpleSearchForm_SearchTerm').focus();
						}, 500);
					}
					else {
						showMiniCart();
						showMiniShopCartDropDownEvent(evt, "MiniShoppingCart", "MiniShopCartContents", "orderItemsList");
						setTimeout(function() {
							$('.mini-cart.tab.persist-active #MiniShopCartContents').find('a')[0].focus();
						}, 500);
					}
				} 
				else if  (evt.target.tagName == "I" && pressedKey === 9) {
					hideSearchElement();
					hideMiniCart();
				}				
				else if (keyboardHelper.isMenuKey(evt.keyCode)) {
					var mainNavOpen = $topLevelNavItems.filter('.'+menuOpenClass).length > 0;
					var petNavOpen = $petMenuNavItems.filter('.'+menuOpenClass).length > 0;
					var $currentPetMenuItem = $petMenuNavItems.filter('.'+menuOpenClass);
					var $currentTopLevelMenuItem = mainNavOpen ?
						$topLevelNavItems.filter('.'+menuOpenClass) :
						$topLevelNavItems.has('> a[tabindex="0"]');

					if (pressedKey === keyboardHelper.keys.ESCAPE) {
						evt.preventDefault();
						evt.stopPropagation();
						dismissDesktopNav(true);
						return;
					}

					if (pressedKey === keyboardHelper.keys.LEFTARROW) {
						evt.preventDefault();
						evt.stopPropagation();
						var $prev = getPreviousItem($topLevelNavItems, $currentTopLevelMenuItem);
						shiftFocus($topLevelNavItems, $prev);
						if (menuItemIsOpen($currentTopLevelMenuItem)) {
							openTopLevelMenuItem($prev, true);
						}
						return;
					}

					if (pressedKey === keyboardHelper.keys.RIGHTARROW) {
						evt.preventDefault();
						evt.stopPropagation();
						var $next = getNextItem($topLevelNavItems, $currentTopLevelMenuItem);
						shiftFocus($topLevelNavItems, $next);
						if (menuItemIsOpen($currentTopLevelMenuItem)) {
							openTopLevelMenuItem($next, true);
						}
						return;
					}

					if (mainNavOpen) {
						switch(pressedKey) {
							case keyboardHelper.keys.UPARROW:
								evt.preventDefault();
								evt.stopPropagation();
								if (petNavOpen) {
									var $openPetMenu = $container.find('.drawer.'+menuOpenClass+' '+$petMenuNavItems.selector);
									var $prev = getPreviousItem($openPetMenu, $currentPetMenuItem);
									shiftFocus($openPetMenu, $prev);
									openPetMenuItem($prev);
								}
								break;
							case keyboardHelper.keys.DOWNARROW:
								evt.preventDefault();
								evt.stopPropagation();
								if (petNavOpen) {
									var $openPetMenu = $container.find('.drawer.'+menuOpenClass+' '+$petMenuNavItems.selector);
									var $next = getNextItem($openPetMenu, $currentPetMenuItem);
									openPetMenuItem($next);
									shiftFocus($openPetMenu, $next);
								}
								break;
							case keyboardHelper.keys.SPACEBAR:
							case keyboardHelper.keys.ENTER:
								evt.preventDefault();
								evt.stopPropagation();
								var $link = $topLevelContent.find(':focus');
								if ($link.length) {
									window.location = $link.attr('href');
								}
								break;
							default:
								break;
						}
					} else {
						switch (pressedKey) {
							case keyboardHelper.keys.UPARROW:
							case keyboardHelper.keys.DOWNARROW:
								evt.preventDefault();
								evt.stopPropagation();
								openTopLevelMenuItem($currentTopLevelMenuItem, true);
								break;
							case keyboardHelper.keys.SPACEBAR:
							case keyboardHelper.keys.ENTER:
								evt.preventDefault();
								evt.stopPropagation();
								toggleToplevelMenu($currentTopLevelMenuItem);
								break;
							default:
								break;
						}
					}
				}
			});

			$topLevelNavItems.on('mouseenter', function() {
				openTopLevelMenuItem($(this));
			});

			$topLevelNavItems.on('mouseleave', function() {
				if (MouseObserver.hoverTimeout) {
					clearTimeout(MouseObserver.hoverTimeout);
				}
			});

			$topLevelContentWrapper.each(function() {
				var container = $(this);
				var drawer = container.find('.drawer');
				if (drawer) {
					container.on('mouseover', function(e) {
						var elm = e.target;
						var isDrawerOrDecendent = $.contains(drawer[0], elm) || $(elm).is(drawer);
						if (!isDrawerOrDecendent) {
							dismissDesktopNav();
						}
					});
				}
			});

			$container.on('mouseleave', dismissDesktopNav);
			$navMask.on('mouseenter', dismissDesktopNav);

			$petMenuNavItems.on('mouseenter', function() {
				openPetMenuItem($(this));
			});

			$brandFilters.on('click', function() {
				var brandLetter = $(this).attr("class");
				var scrollEle = $('.shop-by-brand-fullpage .brand-list a[href="#'+brandLetter+'"]');
				var scrollTo = scrollEle.offset().top*1 - 50*1;
				window.scrollTo(0, scrollTo);
				scrollEle.focus();
			});
		}

		function removeEventListeners() {
			$container.off('keydown');
			$topLevelNavItems.off('mouseenter');
			$topLevelNavItems.off('mouseleave');
			$topLevelContentWrapper.off('mouseover');
			$container.off('mouseleave');
			$navMask.off('mouseenter');
			$petMenuNavItems.off('mouseenter');
			$brandFilters.off('click');
		}
		function cloneHeaderOffers() {
			if (!$('#nav-header-offer').length) {
				var $headerOffer = $('#header-offer').clone();
				$headerOffer.removeClass('header-offer-mobile').attr('id', 'nav-header-offer');
				$('ul.nav-items').append($headerOffer);
				$('ul.nav-items #nav-header-offer').wrap('<li class="header-offer-desktop"></li>');
			}
		}
		return {
			init: function() {
				if (!initialized) {
					addEventListeners();
					cloneHeaderOffers();
					initialized = true;
				}
			},
			destruct: function() {
				if (initialized) {
					removeEventListeners();
					initialized = false;
				}
			}
		}
	})();

	hookExpandablePromos();
if($("#reactHeader").length ==0){
	on(window, 'scroll', function() {
		pageScroll();
	});
}


	hookActivationElements();

	var mq = window.matchMedia( '(max-width: 769px)' );

	if (!mq.matches){
		persistentUtility();
		desktopNav.init();
	} else {
		mobileNav();
	}

	window.addEventListener("resize", resizeThrottler, false);

	var resizeTimeout;
	function resizeThrottler() {
		if ( !resizeTimeout ) {
			resizeTimeout = setTimeout(function() {
				resizeTimeout = null;
				actualResizeHandler();
			}, 66);
		}
	}

	function actualResizeHandler() {
		var mq = window.matchMedia( '(max-width: 768px)' );

				if (!mq.matches){
			persistentUtility();
			desktopNav.init();
		} else {
			desktopNav.destruct();
			mobileNav();
		}
	}

	hookMobileFooter();
	hookSearchHandlers();
	hookDepartmentMenus();


	function pageScroll() {
		var fullHeader = dojo.byId('headerWidget'),
			banner = dojo.byId('header-top-banner'),
			navbar = dojo.byId('primary-nav'),
			headerHeight = (fullHeader) ? dojo.position(fullHeader).h : 0,
		    bannerHeight = (banner) ? dojo.position(banner).h : 0,
		    navHeight = (navbar) ? dojo.position(navbar).h : 0,
			body = dojo.body(),
			bodyPadding = headerHeight + navHeight - bannerHeight;

		if (!fullHeader) {
			return;
		}
		if (mq.matches) { 
			if (bannerHeight < $(window).scrollTop() && !$('body').hasClass('sticky-header')) {
				$('body').addClass('sticky-header');
				$('#headerWidget').css('margin-bottom', $('#header').outerHeight());
				relocateControlsForPersistent();
				$('#look-ahead').removeClass('active');
			}
			if (bannerHeight >= $(window).scrollTop() && $('body').hasClass('sticky-header')) {
				$('body').removeClass('sticky-header')
				$('#headerWidget').css('margin-bottom', 0);
			}
		}
		else { 
			$('#headerWidget').css('margin-bottom', 0);

						if ((dojo.position(fullHeader).y + dojo.position(fullHeader).h) <= 0 && !dojo.hasClass(body, 'sticky-header')) {
				$('#search').attr('aria-expanded', 'false');
				$('.mini-cart.tab.persist-active').attr('aria-expanded', 'false');
				domClass.add(body, 'sticky-header');
				$('#look-ahead').removeClass('active');
				domStyle.set(body, 'padding-top', bodyPadding+'px');
				relocateControlsForPersistent();
				setTimeout(function(){
					domClass.add(query('#search')[0], 'persist-active');
					if ($('.mini-cart')[0] != null && $('.mini-cart')[0] != undefined){
						domClass.add(query('.mini-cart')[0], 'persist-active');
					}					
				}, 300);
			}

			if( (dojo.position(fullHeader).y ) >= 0 && dojo.hasClass(body, 'sticky-header')) {
				domClass.remove(body, 'sticky-header');
				domClass.remove(query('#search')[0], 'persist-active active');
				if ($('.mini-cart')[0] != null && $('.mini-cart')[0] != undefined){
					domClass.remove(query('.mini-cart')[0], 'persist-active');
				}
				domStyle.set(body, 'padding-top', 0);
				domStyle.set(dojo.byId('search'), {
					'left': 'auto',
					'right' : 'auto'
				});
				if ($('.mini-cart')[0] != null && $('.mini-cart')[0] != undefined){
					domStyle.set(query('.mini-cart')[0], {
						'left': '',
						'right' : ''
					});
				}
			}
		}
	}

	function relocateControlsForPersistent() {
		var persistentSearch = query('.persistent-search')[0],
			searchDropdown = dojo.byId('search');
		var mq = window.matchMedia( '(max-width: 768px)' );
		if (query('body.sticky-header').length > 0){
			var searchWidth = dojo.position(searchDropdown).w,
				searchPosition = dojo.position(persistentSearch).x

			if (searchPosition + (searchWidth/2) < window.innerWidth){
				if(mq.matches){
					domStyle.set(searchDropdown, {
						'left' : '0px',
						'right' : 'auto'
					});
				}else{
					domStyle.set(searchDropdown, {
						'left' : searchPosition - (searchWidth/2) + 'px',
						'right' : 'auto'
					});
				}


											} else {
				domStyle.set(searchDropdown, {
					'right' : '20px',
					'left' : 'auto'
				});
			}
		}
	}
	function showSearchElement() {
		var searchDropdown = dojo.byId('search');
		$('#search').attr('aria-expanded', 'true');
		if (query('body.sticky-header').length > 0){
			domClass.add(searchDropdown, 'active');
		}
	}
	function hideSearchElement() {
		var searchDropdown = dojo.byId('search'),
				input = document.getElementById("SimpleSearchForm_SearchTerm");
		$('#search').attr('aria-expanded', 'false');
		if (input !== document.activeElement) {
			domClass.remove(searchDropdown, 'active');
		}
	}
	function showMiniCart() {
		$('.mini-cart.tab.persist-active').attr('aria-expanded', 'true');
		var persistentCart = query('.persistent-cart')[0],
			cartDropdown = query('.mini-cart')[0];
		if (query('body.sticky-header').length > 0){
			toggleMiniShopCartDropDown('mini-cart-icon', 'quick_cart_container', 'orderItemsList');
			domClass.add(cartDropdown, 'active');

			var cartWidth = dojo.position(cartDropdown).w,
				cartPosition = dojo.position(persistentCart).x

			if (cartPosition + (cartWidth/2) < window.innerWidth){
				domStyle.set(cartDropdown, {
					'left' : cartPosition - (cartWidth/2) + 'px',
					'right' : 'auto'
				});
			} else {
				domStyle.set(cartDropdown, {
					'right' : '0px',
					'left' : 'auto'
				});
			}
		}
	}
	function hideMiniCart() {
		var cartDropdown = query('.mini-cart')[0];
		$('.mini-cart.tab.persist-active').attr('aria-expanded', 'true');
		domClass.remove(cartDropdown, 'active');
	}
	function persistentUtility() {
		var mq = window.matchMedia( '(max-width: 768px)' );
		if (!mq.matches){
			query('.persistent-search, #search').on('mouseover', function(){
				showSearchElement();
					setTimeout(function() {
						if($('input#SimpleSearchForm_SearchTerm').length > 0){
							$('input#SimpleSearchForm_SearchTerm').focus();
						}
					}, 500);
			});
			query('.persistent-search, #search').on('mouseout', function(){
				setTimeout(function() {
				     hideSearchElement();
				  }, 500);
			});

			query('.persistent-cart, .mini-cart.tab').on('mouseover', function(){
				showMiniCart();
			});
			query('.persistent-cart, .mini-cart.tab').on('mouseout', function(){
				 hideMiniCart();
			});
		}
	}


	function mobileNav(){
		var mobileMenu = document.getElementById('mobile-menu');
		var mobileOverlay = document.getElementById('mobileOverlay');
		var miniCart = document.getElementById('MiniShoppingCart');
		var topMenuItemIDs = [ 'stores','MiniShoppingCart','search' ]; 

		if (mobileOverlay) {
			mobileOverlay.onclick = function(e) { closeAllMenus(); };
			mobileOverlay.ontouchmove = function(e) { closeAllMenus(); };
		}
		var header = document.getElementById('header');
		if (header) {
			header.ontouchmove = function(e) { if ($(mobileOverlay).hasClass('active')) e.preventDefault(); }
		}
		if (mobileMenu && mq.matches){
			var primaryNav 		= document.getElementById('primary-nav'),
					navExit 	= document.getElementById('nav-exit'),
					closeSubcat	= document.querySelectorAll('.mobile-header'),
					toggleOpen	= document.querySelectorAll('.toggle-open'),
					brandFilter = document.querySelectorAll('.shop-by-brand-fullpage .brand-filter a'),
					brandList	= document.querySelectorAll('.shop-by-brand-fullpage .brand-list > ul > li');

			if (primaryNav) {
				mobileMenu.onclick = function(e){
					closeAllMenus();
					primaryNav.classList.add('active');
					document.body.classList.add('no-scroll');
				}

					navExit.onclick = function(e){
					var openNav = document.querySelectorAll("#primary-nav .open");

										for (var on=0; on<openNav.length; on++){
						openNav[on].classList.remove('open');
					}

					primaryNav.classList.remove('active');
					document.body.classList.remove('no-scroll');
				}

								for (var to=0; to<toggleOpen.length; to++){
					toggleOpen[to].onclick = function(e){
						e.preventDefault();
						this.classList.toggle('open');
					}
				}



																for (var bf=0; bf<brandFilter.length; bf++){

										brandFilter[bf].onclick = function(e){
						e.preventDefault();

												var active = document.querySelectorAll('.brand-filter a.active'),
							thisClass = this.classList[0];

												for (var a=0; a<active.length; a++){
							active[a].classList.remove('active');
						}
						this.classList.add('active');

												if (thisClass === "all"){
							for (var fbl=0; fbl<brandList.length; fbl++){
								brandList[fbl].style.display = "block";
							}
						} else {
							for (var bl=0; bl<brandList.length; bl++){
								brandList[bl].style.display = "none";
							}

														document.querySelectorAll(".shop-by-brand-fullpage .brand-list ."+thisClass)[0].style.display = "block";
							$('html, body').animate({
						        scrollTop: $('#'+thisClass).offset().top-300
						    }, 500);
						}
					}


														}





															}

			var mobileSearch = document.getElementById('mobile-search');

			if (mobileSearch) {
				mobileSearch.onclick = function(e){
					e.preventDefault();
					document.getElementById("search").style.left = "0";
					openMenu("search");
				}
			}

			var mobileStores = document.getElementById('mobile-stores');

			if (mobileStores) {
				mobileStores.onclick = function(e){
					e.preventDefault();
					openMenu("stores");
				};
			}

			var mobileCart = document.getElementById('mobile-cart');

			if (mobileCart) {
				mobileCart.onclick = function(e) {
					e.preventDefault();
					document.querySelectorAll(".mini-cart")[0].style.left = "0";
					toggleMiniShopCartDropDown('mini-cart-icon', 'quick_cart_container', 'orderItemsList');
					openMenu("MiniShoppingCart");
				}
			}
		}

		function closeAllMenus() {
			openMenu('none');
		}

		function openMenu(menu) {
			var aMenuIsOpen = false;
			for(var mi = 0; mi < topMenuItemIDs.length; mi++) {
				if (topMenuItemIDs[mi] != menu) {
					domClass.remove(topMenuItemIDs[mi], "open");
				} else {
					domClass.add(topMenuItemIDs[mi], "open");
					aMenuIsOpen = true;
				}
			}
			if (aMenuIsOpen) {
				$('#mobileOverlay').css('display', 'block');
			} else {
				$('#mobileOverlay').css('display', 'none');
			}
		}
	}

	function hookMobileFooter() {
		var footerNav = dojo.byId('footer');

		if (footerNav && mq.matches){
			var footerTab = query('#footer h5');

			on(footerTab, 'click', function(){
				domClass.toggle(this, 'open');
			});
		}

		if  (document.querySelectorAll("#policy-collapse").length > 0){
			var collapsible = document.querySelectorAll("#policy-collapse")[0];	

						collapsible.onclick = function(e){
				e.preventDefault()

								if (this.nextElementSibling.classList.contains("open")){
					this.nextElementSibling.classList.remove("open");
				} else {
					this.nextElementSibling.classList.add("open");
				}
			}
		}
	}


	function activate(targetElem) {
		var departmentMenuPrefix = 'departmentMenu_'; 
		var startsWith = (targetElem.id.slice(0,departmentMenuPrefix.length) == departmentMenuPrefix);
		if (startsWith) {
			wc.render.updateContext('departmentSubMenuContext', {'targetId':targetElem.id});
			if (typeof cX === 'function') {
				setTimeout(function(){cX('');}, 1000);
			}
			return;
		}

		var parentId = targetElem.getAttribute('data-parent');
		if (parentId && activeElements[parentId]) {
			deactivate(activeElements[parentId]);
		}
		if (parentId) {
			activate(document.getElementById(parentId));
		}
		domClass.add(targetElem, 'active');
		query('a[data-activate="' + targetElem.id + '"]').addClass('selected');
		query('a[data-toggle="'   + targetElem.id + '"]').addClass('selected');
		activeElements[parentId] = targetElem;
	}

	function toggle(targetElem) {
		if (domClass.contains(targetElem, 'active')) {
			deactivate(targetElem);
		}
		else {
			activate(targetElem);
		}
	}

	function hookActivationElements() {
		on(document, 'a[data-activate]:click', function(e) {
			var target = this.getAttribute('data-activate');
			activate(document.getElementById(target));
			event.stop(e);
		});
		on(document, 'a[data-deactivate]:click', function(e) {
			var target = this.getAttribute('data-deactivate');
			deactivate(document.getElementById(target));
			event.stop(e);
		});
		on(document, 'a[data-toggle]:click', function(e) {
			var target = this.getAttribute('data-toggle');
			if (document.getElementById(target) != null) {
				toggle(document.getElementById(target));
			}
			event.stop(e);
		});
		on(document, 'a[data-toggle]:keydown', function(e) {
			var target;
			if (e.keyCode == 27) {
				target = this.getAttribute('data-toggle');
				deactivate(document.getElementById(target));
				event.stop(e);
			} else if (e.keyCode == 40) {
				target = this.getAttribute('data-toggle');
				var targetElem = document.getElementById(target);
				activate(targetElem);
				query('[class*="menuLink"]', targetElem)[0].focus();
				event.stop(e);
			}
		});
		if (has('ie') < 10) {
			query('input[placeholder]').forEach(function(input) {
				var placeholder = input.getAttribute('placeholder');
				if (placeholder) {
					var label = document.createElement('label');
					label.className = 'placeholder';
					label.innerHTML = placeholder;
					var updatePlaceholder = function() {
						label.style.display = (input.value ? 'none' : 'block');
					};
					window.setTimeout(updatePlaceholder, 200);
					on(input, 'blur, focus, keyup', updatePlaceholder);
					on(label, 'click', function() {
						input.focus();
					});
				}
			});
		}
	}

	function hookSearchHandlers() {
		window.setTimeout(function() {
			var searchForm = document.getElementById('SimpleSearchForm_SearchTerm');
			if (searchForm) {
				on(searchForm, 'click', function() {
					var allSelectedDataToggles = query('.selected:not(a[data-toggle="searchBar"])', document.getElementById('header'));
					allSelectedDataToggles.forEach(function(selectedDataToggle) {
						deactivate(document.getElementById(selectedDataToggle.getAttribute('data-toggle')));
					});
				});
			}
		}, 100);

		query('#searchBox > .submitButton').on('click', function() {
			var searchTerm = document.getElementById('SimpleSearchForm_SearchTerm');
			searchTerm.value = lang.trim(searchTerm.value);
			var unquote = lang.trim(searchTerm.value.replace(/'|"/g, ''));
			if (searchTerm.value && unquote != '') {
				document.getElementById('searchBox').submit();
			}
		});

		query('#searchBox').on('submit', function(e) {
			var searchTerm = document.getElementById('SimpleSearchForm_SearchTerm');
			var origTerm = searchTerm.value;
			var unquote = lang.trim(searchTerm.value.replace(/'|"/g, ''));
			searchTerm.value = unquote;
			if (!searchTerm.value) {
				event.stop(e);
				return false;
			}
			searchTerm.value= lang.trim(origTerm).toLowerCase();
		});

				query('#SimpleSearchForm_SearchTerm').on('keyup', function(){
			var searchBox = document.getElementById('SimpleSearchForm_SearchTerm'),
				searchButton = document.getElementById('submitButton');

						if (searchBox.value.length > 0){
				searchButton.classList.add("active");
			} else {
				searchButton.classList.remove("active");
			}
		});
	}

	function hookDepartmentMenus() {
		wc.render.declareContext('departmentSubMenuContext',{targetId: ''},'');
		wc.render.declareRefreshController({
			id: 'departmentSubMenu_Controller',
			renderContext: wc.render.getContextById('departmentSubMenuContext'),
			url: '',
			formId: '',
			renderContextChangedHandler: function(message, widget) {
				cursor_wait();
				widget.refresh(this.renderContext.properties);
			},
			postRefreshHandler: function() {
				updateDepartmentsMenu(); 
				activate(document.getElementById(this.renderContext.properties.targetId)); 
				cursor_clear();
			}
		});
	}

	function hookExpandablePromos() {
		var expandablePromo = query('.expandable');
		if (expandablePromo){
			on(expandablePromo, 'click', function(){
				domClass.toggle(this, 'open');
			});
		}
		var $bannerPromo = $('.banner-promo .collapse-toggle');
		if ($bannerPromo) {
			var $bannerClose = $('.banner-promo .close'),
					$promoLinks  = $('.banner-promo .carousel-inner .active a');
			if (!$bannerPromo.attr('tabindex')) {
				$bannerPromo.attr('tabindex', '0');
			}
			if (!$bannerPromo.attr('aria-label')) {
				$bannerPromo.attr('aria-label', $bannerPromo.find('.carousel-inner .item p').text() + ' expandable promotion');
			}
			if (!$bannerPromo.attr('aria-expanded')) {
				$bannerPromo.attr('aria-expanded', 'false');
			}
			if (!$bannerPromo.attr('role')) {
				$bannerPromo.attr('role', 'button');
			}
			$bannerPromo.on('click keydown', function(e){
				if (e.type == "click" || e.which == "13") {
					$(this).addClass('open');
					$('.banner-promo .collapsible').addClass("open");
					$bannerPromo.attr('aria-expanded', 'true').attr('tabindex', '-1');
					$bannerClose.attr('tabindex', '0');
					$promoLinks.each(function(index) {
						$(this).attr('tabindex', '0');
					});
				}
			});
			$bannerClose.on('click keydown', function(e){
				if (e.type == "click" || e.which == "13") {
					$('.banner-promo .collapse-toggle').removeClass("open");
					$('.banner-promo .collapsible').removeClass("open");
					$bannerPromo.attr('aria-expanded', 'false').attr('tabindex', '0');
					$bannerClose.attr('tabindex', '-1');
					$promoLinks.each(function(index) {
						$(this).attr('tabindex', '-1');
					});
				}
			});
		}
		$('.carousel-sync').on('click', '.carousel-control[data-slide]', function (ev) {
		    ev.preventDefault();
		    $('.carousel-sync').carousel($(this).data('slide'));
		});
		$('.carousel-sync').on('mouseover', function(ev) {
		    ev.preventDefault();
		    $('.carousel-sync').carousel('pause');
		});
		$('.carousel-sync').on('mouseleave', function(ev) {
		    ev.preventDefault();
		    $('.carousel-sync').carousel('cycle');
		});
	}


		});


function deactivate(targetElem) {
	if(targetElem == null){
		return;
	}
	if (activeElements[targetElem.id]) {
		deactivate(activeElements[targetElem.id]);
	}

	require([
		'dojo/dom-class',
		'dojo/query'
	], function(domClass, query) {

		domClass.remove(targetElem, 'active');
		query('a[data-activate="' + targetElem.id + '"]').removeClass('selected');
		query('a[data-toggle="' + targetElem.id + '"]').removeClass('selected');
		var parent = targetElem.getAttribute('data-parent');
		delete activeElements[parent];
	});
}

var userType= "";
var isGuest = true;
var parameters = [];
var domain = '';
if($("#cookieDomain").length > 0){
	domain = $("#cookieDomain").val();
}

function invokeCookieForLoginUser(newCookieValue,newUserIdValue){
	require(['dojo/cookie'], function(cookie) {
		cookie("WC_UserType", newCookieValue, {path:'/'});
		cookie("WC_UserId", newUserIdValue, {path:'/'});
		cookie("rUserType", newCookieValue, {path:'/',domain:domain});
	});
	var isGuest = newCookieValue == 'G';
	var loggedIn = document.getElementById('logged-in'),
		loggedOut = document.getElementById("logged-out");
	var gOneTap = document.getElementById("oneTapScript"); 
	var isOneTapEnabledPage = window && window.page && window.page.page_name_join && (window.page.page_name_join === "Home:Home Page" || window.page.page_name_join === "account:Sign In" || window.page.page_name_join === "account:Registration" ) ? true : false; 
	var isGoogleCreateConnect = document.getElementsByClassName("googlecreateconnect");
	var isCartPage = false;
	var isCheckoutInterstitialPage = false;
	if($(location).attr('href').indexOf('/OrderItemDisplay')>0){
		isCartPage = true;
	}
	if($(location).attr('href').indexOf('/PetcoInterstitialLogonFormView')>0){
		isCheckoutInterstitialPage = true;
	}
	if (loggedIn && loggedOut) {
		if(isGuest) {
			loggedIn.style.display = 'none';
			loggedIn.classList.remove('active');
			loggedOut.style.display = 'block';
			loggedOut.classList.add('active');
		}else{
			loggedIn.style.display = 'block';
			loggedIn.classList.add('active');
			loggedOut.style.display = 'none';
			loggedOut.classList.remove('active');
			$('#logged-in a').focus(function(e) {
				$(this).parents('#logged-in').css('visibility', 'visible');
			});
			var optedOutPALSInfo = getCookie("optedOut") ;
			var className =(optedOutPALSInfo == null || optedOutPALSInfo == '' || optedOutPALSInfo=='false') ? 'show' : 'hide';	
			    var palsAccountHeaderLink = document.getElementById('pals-header-link');   
			    if(palsAccountHeaderLink != undefined && palsAccountHeaderLink != null){
				 palsAccountHeaderLink.classList.remove('btn', 'btn-primary', 'margin-bottom-sm');
			palsAccountHeaderLink.classList.add('btn', 'btn-primary', 'margin-bottom-sm',className);
			    }
		}
	}
	if(gOneTap && isGuest && !isGoogleCreateConnect.length > 0 && isOneTapEnabledPage){
		var newScript = document.createElement("script");
		newScript.src = "https://accounts.google.com/gsi/client";
		gOneTap.appendChild(newScript);
	}
	var accountDiv = document.querySelectorAll('.account .active')[0],
	accountContainer = document.getElementById('account-container');
	if(accountDiv && accountContainer){
		var accountClone = accountDiv.cloneNode(true);
		accountContainer.appendChild(accountClone);
	}

		dojo.topic.publish("ajax_usertype_changed", newCookieValue);

	}


$( document ).ready(function() {
	wc.service.declare({
		id: "pingPetcoUserTypeAction",
		actionId: "pingPetcoUserTypeAction",
		url: $("span#PetcoPingUserTypeurl").html().trim().split("&amp;").join("&"),
		successHandler: function(response) {
			var newCookieValue = response.usertype;
			var newUserIdValue =  response.userid;
			invokeCookieForLoginUser(newCookieValue,newUserIdValue);
		}

			,failureHandler: function(response) {
			console.debug("PetcoPingUserType: Unexpected error occurred during an xhrPost request.");
		}

	})

		var isRfkCallCountInit=8;
			var isRfkCallInit = setInterval(function(){
			if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) == 'function'){
					   clearInterval(isRfkCallInit);
					   isRfkCallCountInit=10;
					   ReflektionHelperJS.reflektion_init();					  
				}else if(isRfkCallCountInit == 0){
						clearInterval(isRfkCallInit);
					    isRfkCallCountInit=10;
						ReflektionHelperJS.reflektion_init();						 
				}else{
					isRfkCallCountInit--;
				}
			}, 800);
	pingPetcoUserType();
});
